"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WABA360DialogApiClientPayloadsEnumsParameterType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var WABA360DialogApiClientPayloadsEnumsParameterType;
(function (WABA360DialogApiClientPayloadsEnumsParameterType) {
    WABA360DialogApiClientPayloadsEnumsParameterType["Text"] = "text";
    WABA360DialogApiClientPayloadsEnumsParameterType["Currency"] = "currency";
    WABA360DialogApiClientPayloadsEnumsParameterType["DateTime"] = "date_time";
    WABA360DialogApiClientPayloadsEnumsParameterType["Image"] = "image";
    WABA360DialogApiClientPayloadsEnumsParameterType["Document"] = "document";
    WABA360DialogApiClientPayloadsEnumsParameterType["Video"] = "video";
    WABA360DialogApiClientPayloadsEnumsParameterType["Payload"] = "payload";
})(WABA360DialogApiClientPayloadsEnumsParameterType = exports.WABA360DialogApiClientPayloadsEnumsParameterType || (exports.WABA360DialogApiClientPayloadsEnumsParameterType = {}));
